/**
 * reducers/path-debug.ts
 * desc: path debug UI reducer
 * note: holds what the debugging screen has to remember across components
 */

import type { Reducer } from '@reduxjs/toolkit';
import type { OutputPath, PathDebugAction } from '../actions/path-debug';

export interface PathDebugState {
    outputPath: OutputPath | null;
}

const INITIAL_STATE: PathDebugState = {
    outputPath: null,
};


function pathDebugReducer(state: PathDebugState = INITIAL_STATE, action: PathDebugAction): PathDebugState {
    if (action.type === 'SET_PATH_DEBUG_OUTPUT_PATH') {
        return _setOutputPath(state, action.payload);
    }
    return state;
}

function _setOutputPath(state: PathDebugState, payload: OutputPath | null): PathDebugState {
    return {
        ...state,
        outputPath: payload,
    };
}

export default pathDebugReducer as Reducer<PathDebugState>;
